import React from 'react'
import { TextArea } from '../ui/inputs/TextArea';
import { postTextDirection } from '../../api/ownerdatas';
import { showToastError, showToastSuccess } from '../../services/toast';
import { useDashboardStore } from '../../stores/dashboard';
import { ModalButton, ModalShell } from '../ui/modals/ModalShell';

const UpdateInfo = ()=> {

    const {textDirection, setTextDirection, update, setUpdate, setOpenModalInforDirection} = useDashboardStore()

    const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      setTextDirection(e.target.value);
      };
      
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        postTextDirection(textDirection)
          .then(() => {
            showToastSuccess("Texte modifié avec succès !");
            setUpdate(!update);
            setOpenModalInforDirection(false);
          })
          .catch(() => {
            showToastError("Erreur lors de la soumission !");
          });
    }

  return (
    <ModalShell
      title="Modifier le texte"
      size="lg"
      onClose={() => setOpenModalInforDirection(false)}
      footer={
        <>
          <ModalButton
            variant="secondary"
            onClick={() => setOpenModalInforDirection(false)}
          >
            Annuler
          </ModalButton>
          <ModalButton variant="primary" onClick={handleSubmit}>
            Valider
          </ModalButton>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="font-Nunito">
        <TextArea
          label="Renseignez le texte"
          name="text"
          value={textDirection || ""}
          onChange={handleChangeTextArea}
          clasName="w-full"
        />
      </form>
    </ModalShell>
  )
}

export default UpdateInfo
